import styled from "styled-components";

export const Container = styled.div`
    .step-container {
        justify-content: space-between;
        width: 24em;
        max-width: 90%;
        max-height: 90%;
        flex: 1;
        align-self: center;
        box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
        border-radius: 40px;
        padding: 1em 2em;
        background: white;
        margin-left: auto;
        margin-right: auto;

        input[type=radio] {
            appearance: none;
            width: 1em;
            height: 1em;
            display: block;
            border: 1px solid #303030;
            border-radius: 2px;
            margin: auto 0.5em auto 0;
        }

        input[type=radio]:checked {
            border: 1px solid var(--primary-color-lt);
            background: var(--primary-color-lt);
        }
    }

    .vertical-step-container {
        height: auto;
        display: block;
    }

    button.nextButton {
        background-color: var(--primary-color-lt);
        border-radius: 64px;
        color: white;
        width: 48%;
        border: none;
        cursor: pointer;
        transition: background-color 0.3s;
        font-family: "Nunito";
        font-size: 16px;

    }


    button.nextButton:not(:disabled):hover {
        background-color: var(--primary-color);
        outline: none;
        box-shadow: none;
        color: white;
        width: 48%;
        opacity: 0.9;
    }

    button.nextButton:not(:disabled) {
        background-color: var(--primary-color);
        width: 48%;
    }

    button.nextButton:disabled {
        background-color: var(--primary-color-lt);
        cursor: not-allowed;
        opacity: 0.6;
        width: 48%;

    }

    .custom-input {
        width: 100%;
        padding: 8.5px;
        box-sizing: border-box;
        border: 1px solid silver;
        border-radius: 4px;
        outline: none;
    }

    .custom-input:focus {
        border: 2px solid royalblue;
    }

    .BlackTitleStepTwo {
        font-size: 1.6em;
        font-weight: 600;
        text-align: center;
        width: 100%;
        font-family: "Nunito";
        background-clip: text;
        margin-top: 1vh;
        margin-bottom: 10%;
    }

    .IconVertical {
        margin: 0.5em;
        height: 2em;
        width: 2em;
        vertical-align: middle;
    }

    .verticalContainer {
        border-radius: 8px;
        border: 1px solid #303030;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.5em;
        transition: all 0.2s ease;
        cursor: pointer;
    }

    .verticalContainer:hover {
        background-color: rgba(81, 72, 249, 0.07);
        border-color: #5148F9;
    }


    .leftContent {
        display: flex;
        align-items: center;
        gap: 0.75em;
    }

    .verticalContainer:hover .verticalText {
        color: #5148F9;
    }

    .activeVertical {
        color: #5148F9;
        border-color: #5148F9;
        background-color: rgba(81, 72, 249, 0.07);
    }

    .verticalText {
        font-family: "Nunito";
        line-height: inherit;
        font-size: 16px;
    }

    .checkboxSquare {
        height: 20px;
        width: 20px;
        min-width: 20px;
        border-radius: 4px;
        background-color: #fff;
        margin-right: 10px;
        border: 1px solid #d9d9d9;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.2s ease;
    }

    .verticalContainer:hover .checkboxSquare {
        border-color: #5148f9;
    }

    .checkboxSquare.checked {
        background-color: #5148f9;
        border-color: #5148f9;
    }

    .checkmark {
        font-size: 14px;
        color: white;
        line-height: 1;
    }

    .skipButton {
        background-color: white;
        border-radius: 64px;
        color: #e0e2e4;
        width: 48%;
        border: none;
        cursor: pointer;
        transition: background-color 0.3s;
        font-family: "Nunito";
        font-size: 16px;
        font-weight: 400;
        margin-right: 4%;
    }

    .skipButton:hover {
        background-color: var(--primary-color-lt);
        border-radius: 64px;
        color: #e0e2e4;
        width: 48%;
        border: none;
        cursor: pointer;
        transition: background-color 0.3s;
        font-family: "Nunito";
        font-size: 16px;
        font-weight: 400;
        margin-right: 4%;
    }

    .BlackTitle {
        font-size: 22px;
        font-weight: 600;
        text-align: center;
        font-family: "Nunito";
        background-clip: text;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    button.customButton {
        background-color: var(--primary-color-lt);
        border-radius: 64px;
        color: white;
        width: 100%;
        border: none;
        cursor: pointer;
        transition: background-color 0.3s;
        font-size: 16px;
        margin-top: 1em !important;
        margin-bottom: 1em !important;
    }

    button.customButton:hover {
        opacity: 0.8;
    }

    button.customButton:not(:disabled):hover {
        background-color: var(--primary-color);
        border: none;
        outline: none;
        box-shadow: none;
        width: 100%;
        font-size: 16px;
        opacity: 0.8;
    }

    button.customButton:not(:disabled) {
        background-color: var(--primary-color);
    }

    button.customButton:disabled {
        background-color: var(--primary-color-lt);
        cursor: not-allowed;
        opacity: 0.6;
    }

    @media only screen and (max-width: 600px) {
        /*Phones*/
        .BlackTitle {
            font-size: 1.2em;
            font-weight: 600;
            text-align: center;
            font-family: "Nunito";
            background-clip: text;
            margin-top: 0.2vh;
        }

        .HeaderDesign {
            margin-top: 1vh;
            padding-bottom: 8.5vh;
            padding-left: 10%;
        }

    }

    @media only screen and (max-width: 500px) {
        .step-container {
            padding: 1em 1em;
        }
    }
`;







